import {$hostAuth, $hostPublic} from "../http"

class SettingsService {

    async getAll() {
        const {data} = await $hostPublic.get("/api/settings")
        return data
    }

    async update(dataReq) {
        const {data} = await $hostAuth.patch("/api/settings", dataReq)
        return data
    }

}


export default new SettingsService();